import 'intersection-observer';

/**
 * ログ送信
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param target イベント観測対象。event.targetの取得が困難な場合は、documentで代用可。
 * @param messageID メッセージID
 */
export function sendLog(s: any, target: any, messageID: string) {
  if (!s) return;
  s.tl(target, 'o', messageID);
}

type ScrollLogTargetObject = {
  element: HTMLElement;
  message: string;
};

/**
 * スクロールログinit
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param scrollLogTargetList イベント観測対象
 * @returns 処理後のターゲットリスト
 */
export function initScrollLog(
  s: any,
  scrollLogTargetList: ScrollLogTargetObject[],
  inputOptions: Object | null = null,
): IntersectionObserver[] {
  const defaultOptions = {
    rootMargin: '0px 0px -20% 0px',
    threshold: 0,
  };

  const options = inputOptions !== null ? inputOptions : defaultOptions;
  const instants: IntersectionObserver[] = [];

  if (scrollLogTargetList.length === 0) return [];
  scrollLogTargetList.forEach((target) => {
    const observerInstance = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        sendLog(s, target.element, target.message);
        observer.unobserve(target.element);
      });
    }, options);

    observerInstance.observe(target.element);
    instants.push(observerInstance);
  });

  return instants;
}

/**
 * スクロールログ終了
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param scrollLogTargetList イベント観測対象
 * @returns 処理後のターゲットリスト
 */
export function finishObserveScrollLog(instants: IntersectionObserver[]): void {
  instants.forEach((instant: IntersectionObserver) => {
    instant.disconnect();
  });
}

/**
 * @description リンク押下時のログ送信
 * @param s 基本的に進路内にグローバルに存在する『s』をいれる
 * @param clickLogElement クリックイベントの対象セレクタ
 * @param trace_p
 */
export class ClickLog {
  clickLogTriggerElements: NodeListOf<HTMLElement>;

  constructor(s: any, clickLogElement: string, trace_p: string) {
    this.clickLogTriggerElements = document.querySelectorAll(clickLogElement);
    this.bindEvent(s, trace_p);
  }

  /**
   * @description 対象のトリガーにイベントをbind
   */
  bindEvent(s: any, trace_p: string) {
    const clickLogTriggerElements = Array.prototype.slice.call(this.clickLogTriggerElements, 0);
    clickLogTriggerElements.forEach((trigger) => {
      trigger.addEventListener('click', (event: any) => {
        const clickedElement = event.currentTarget;
        const logText = clickedElement.getAttribute('data-click-log');
        const logMessage = `${trace_p}${logText}`;
        sendLog(s, clickedElement, logMessage);
      });
    });
  }
}
